import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import { Modal, Menu, Icon } from 'antd'
import { storage } from '@/utils/tools'
import $http from '@/utils/http'
import { IMenu, USER_INFO, UserInfo } from '@/constants'

interface IState {
  name: string
  company: string
  key: string[]
}

const menuList: IMenu[] = [
  // {
  //   key: 'dashboard',
  //   title: 'Dashboard',
  //   path: '/dashboard',
  //   icon: 'dashboard'
  // },{
  //   key: 'setting',
  //   title: 'Setting',
  //   path: '/setting',
  //   icon: 'setting'
  // },
  {
    key: 'logout',
    title: 'Log Out',
    path: '/logout',
    icon: 'logout'
  }
]

class SiderBar extends React.Component<RouteComponentProps> {
  constructor(props) {
    super(props)
  }

  state: IState = {
    name: '',
    company: '',
    key: []
  }

  initMenu = () => {
    if (!$PROD) {
      // 只有线上环境没有
      menuList.push({
        key: 'demos',
        title: 'Demos',
        path: '/admin/demos',
        icon: 'bulb'
      })
    }
    let str = storage.get(USER_INFO),
      userInfo: UserInfo = new UserInfo()
    if (str) {
      userInfo = JSON.parse(str)

      if (userInfo.state !== 'active') {
        menuList.unshift({
          key: 'verifySteps',
          title: 'Verification Steps',
          path: '/admin/verifySteps',
          icon: 'dashboard'
        })
      } else if (userInfo.state === 'active') {
        menuList.unshift({
          key: 'empManage',
          title: 'Employee Management',
          path: '/admin/empManage',
          icon: 'dashboard'
        })
      }
    }
    const { pathname } = this.props.location
    const _path = pathname
      .split('/')
      .slice(0, 3)
      .join('/')
    this.setState({
      key: [_path],
      name: userInfo.name,
      company: userInfo.name
    })
    // if(!this.state.key) {
    //   this.key = [this.menuList[0].key]
    // }
  }

  menuClick = (path: string) => {
    // 判断是否登出
    if (path === '/logout') {
      Modal.confirm({
        title: 'Log Out',
        content: 'Confirm log out?',
        onOk: () => {
          return $http
            .post('/cms/user/logout', {})
            .then(res => {})
            .finally(() => {
              storage.clear()
              location.href = '/'
            })
        }
      })
    } else {
      this.setState({ key: [path] })
      this.props.history.push(path)
    }
  }

  componentDidMount() {
    this.initMenu()
  }

  render() {
    const { key, name, company } = this.state

    return (
      <div className="siderbar">
        <a className="logo" href="/">
          A Card
        </a>
        <div className="userInfo">
          <div className="name">{name}</div>
          <div className="company">{company}</div>
        </div>
        <Menu theme="dark" selectedKeys={key}>
          {menuList.map(menu => {
            return (
              <Menu.Item
                key={menu.path}
                onClick={() => this.menuClick(menu.path)}
              >
                <Icon type={menu.icon} />
                {menu.title}
              </Menu.Item>
            )
          })}
        </Menu>
      </div>
    )
  }
}

export default withRouter(SiderBar)
